
import { defineComponent } from 'vue';
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    props:{
        item: {
            type: null,
            required: true,
            default: {}
        }
    },
    emits: ["click"],
    setup(props, {emit}) {
        const { t } = useI18n();
        const handleClick = () => {
            emit("click", props.item);
        };
        
        return {t,handleClick };
    },
})
